import locale_br from './pt_BR';
import locale_es from './es_ES';
import locale_de from './de_DE';
import locale_zh from './zh_CN';

export * from './config-provider';

const data = {
	'pt-BR': locale_br,
	es: locale_es,
	de: locale_de,
	zh: locale_zh
};

export default data;
